const safeParseJson = <T>(json: unknown): T | null => {
  if (typeof json !== 'string') {
    return null
  }
  const trimmed = json.trim()
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
    return null
  }

  try {
    return JSON.parse(json) as T
  } catch (e) {
    return null
  }
}

export default safeParseJson
